export const PLATFORM_STATUS_ERROR_MESSAGE = 'Ops, we failed at connecting with our Services. Please, check if an' +
    ' AdBlock is running or a VPN is blocking the communication, and try refreshing the page again. ' +
    'If this message remains, contact our support.';